import React, {  } from 'react';
import {  Modal } from 'antd';

interface ModalFormProps {
    modalTitle: string;
    width?: number;
    onOk?: () => void;
    onCancel?: () => void;
    open: boolean;
    Subtitle: string;
    setOpen: React.Dispatch<React.SetStateAction<boolean>>;
    okText?: string;
    cancelText?: string;
}

const ModalForm: React.FC<ModalFormProps> = ({
    modalTitle,
    onOk,
    onCancel,
    open,
    setOpen,
    Subtitle,
    okText,
    cancelText
}) => {
 
    const handleOk = async () => {
        if (onOk) {
            await onOk();
        }
    };

    const handleCancel = () => {
        if (onCancel) {
            onCancel();
        }
    };

    return (
        <>
            <Modal
                title={modalTitle}
                centered
                open={open}
                onOk={handleOk}
                onCancel={handleCancel}
                okText={okText}
                cancelText={cancelText}
                okButtonProps={{
                    style: { backgroundColor: '#095179', color: '#ffffff' },
                }}
            >
             {Subtitle}
            </Modal>
        </>
    );
};

export default ModalForm;
